import { BlobNode } from "./BlobNode.js";

import { Report, CodeError } from "./../Reports/Report.js";

/* ==----------------------------------------------------------------------------------------------------------== */
/* ==----------------------------------------== Class definitions ==-------------------------------------------== */
/* ==----------------------------------------------------------------------------------------------------------== */

/**
 * @description Represents FileNode instances that can be downloaded using a link
 * */
export class DownloadableBlobNode extends BlobNode {

    constructor(name, downloadURL) {
        super(name, null);

        this.downloadURL = downloadURL;
    }

    /**
     * Refer to FileNode.js for description
     * */
    handlesDownloads() {
        return true;
    }

    /**
     * @description Downloads the file at "downloadURL" and stores it as a Blob
     * @returns { Report } A status report indicating possible success / failure
     * */
    async download() {
        if (!this.downloadURL) {
            console.log("Download url is null!");

            throw new CodeError(-1);
        }

        return fetch(
            this.downloadURL,
            {
                crossDomain: true,
                method: "GET",
                headers: {}
            }
        ).then(response => {

            /* [ STEP 1 ] Preliminary checks */

            if (!response.ok || !response.body) {
                throw new CodeError(response.status);
            }

            /* [ STEP 2 ] Fetching file name */

            try {

                let fileName = response.headers.get("content-disposition");
                fileName = fileName.split('filename=')[1].split(';')[0].replaceAll('"', "");
                this.name = fileName;

            } catch (e) {
                console.log("error fetching fileName from content-disposition : ", e)
                this.name = null;
            }

            /* [ STEP 3 ] Managing download */

            return response.blob();           
            
        })
            .then(blob => {
                this.content = blob;

                return Report.http(200);
            })
            .catch((error) => {
                /* [ ERROR ] Unable to download */

                console.log(error);

                return Report.http(error.code);
            });
    }
}
